"use client";

import { PortableText } from "next-sanity";
import { richTextComponent } from "@/sanity/sanityPortableText";
import Image from "@/helpers/Image";
import { PageFuturesLPSchema } from "@/sanity/pages/PageFuturesLPTemplate";

export default function DifferentiatorSection({
  data,
}: {
  data: PageFuturesLPSchema;
}) {
  if (!data.differentiatorTitle && !data.differentiatorCards) return null;

  return (
    <section className="px-[1rem] lg:px-[5rem]">
      <div className="bg-[#04271d] py-[10rem] lg:py-[16rem]">
        <div className="mx-auto w-[min(170rem,100%)] px-[4rem] flex flex-col items-center gap-[3rem]">
          {/* Header */}
          <div className="flex flex-col items-center gap-[1.5rem] text-center max-w-[103.25rem]">
            {data.differentiatorChip && (
              <p className="mb-0 font-blacker italic text-[2.25rem] leading-[1.5] text-white">
                {data.differentiatorChip}
              </p>
            )}

            {data.differentiatorTitle && (
              <div className="relative">
                <div
                  className="richtext richtext-center relative z-[1] flex flex-col gap-0 prose-h2:text-white prose-h2:text-[5rem] lg:prose-h2:text-[7rem] prose-p:mt-[2rem] prose-p:text-white/70 prose-p:max-w-[61.5rem]"
                  style={{ textWrapStyle: "pretty" }}
                >
                  <PortableText
                    value={data.differentiatorTitle}
                    components={richTextComponent}
                  />
                </div>
              </div>
            )}
          </div>

          {/* Cards */}
          {data.differentiatorCards && (
            <div className="flex flex-col lg:flex-row gap-[1.75rem] w-full">
              {data.differentiatorCards.map((card, i) => (
                <div
                  key={card._key ?? i}
                  className="relative flex-1 backdrop-blur-[10px] bg-white/10 rounded-[0.25rem] p-[3rem] flex flex-col gap-[2.75rem]"
                >
                  <div className="absolute left-0 top-0 bottom-0 w-[0.375rem] bg-[#12f0b4]" />

                  {card.icon && (
                    <Image
                      src={card.icon}
                      alt=""
                      className="!w-[6.25rem] object-contain"
                    />
                  )}

                  <div className="flex flex-col gap-[1rem]">
                    {card.title && (
                      <p className="mb-0 font-geist font-medium text-[2.25rem] leading-[1.5] text-white">
                        {card.title}
                      </p>
                    )}
                    {card.body && (
                      <p className="mb-0 font-geist font-normal text-[2.25rem] leading-[1.5] text-white/70">
                        {card.body}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Footer */}
          {data.differentiatorFooter && (
            <div className="richtext richtext-center prose-p:text-[2.25rem] prose-p:leading-[1.5] prose-p:text-white/70 max-w-[61.5rem] [&_br]:hidden lg:[&_br]:block">
              <PortableText
                value={data.differentiatorFooter}
                components={richTextComponent}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
